import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "menu" }
const _hoisted_2 = { class: "icon is-medium" }
const _hoisted_3 = { class: "icon is-medium" }
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = { class: "file" }
const _hoisted_7 = { class: "file-label" }
const _hoisted_8 = { class: "file-cta" }
const _hoisted_9 = { class: "file-icon" }
const _hoisted_10 = { class: "file-label" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "icon" }
const _hoisted_17 = { class: "links" }
const _hoisted_18 = {
  href: "http://www.easynwk.com/",
  target: "_blank"
}
const _hoisted_19 = {
  href: "https://github.com/fhstp/easynwk-web",
  target: "_blank"
}
const _hoisted_20 = { href: "http://www.easynwk.com/impressum/" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: "fhstp_sw_pos.png",
  width: "80",
  height: "80"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorPopup = _resolveComponent("ErrorPopup")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ErrorPopup, {
      visible: _ctx.showErrorPopup,
      onClose: _ctx.closeErrorPopup
    }, null, 8, ["visible", "onClose"]),
    _createElementVNode("button", {
      "data-behavior": "menu-open",
      class: "button is-burger",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.menuOpen = !_ctx.menuOpen), ["stop"]))
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          icon: "bars",
          size: "2x"
        })
      ])
    ]),
    _createElementVNode("div", {
      id: "sidepanel",
      class: _normalizeClass({ shown: _ctx.menuOpen }),
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.menuOpen = false))
    }, [
      _createElementVNode("button", {
        class: "button is-burger closebtn",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.menuOpen = false), ["stop"]))
      }, [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_font_awesome_icon, {
            icon: "times",
            size: "2x"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.newNWK && _ctx.newNWK(...args)))
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, { icon: "file" })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("newNWK")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createElementVNode("input", {
              class: "file-input",
              type: "file",
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
            }, null, 32),
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_font_awesome_icon, { icon: "folder-open" })
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t("open")), 1)
            ])
          ])
        ]),
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, { icon: "save" })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("save")), 1)
        ]),
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openDemoData && _ctx.openDemoData(...args)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.t("openDemo")), 1)
        ]),
        _hoisted_12,
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exportPNG && _ctx.exportPNG(...args)))
        }, [
          _createElementVNode("span", _hoisted_13, [
            _createVNode(_component_font_awesome_icon, { icon: "file-image" })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("exportPNG")), 1)
        ]),
        _createElementVNode("button", {
          class: "button",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportCSV && _ctx.exportCSV(...args)))
        }, [
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_font_awesome_icon, { icon: "file-csv" })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("exportkeyfigures")), 1)
        ]),
        _createElementVNode("a", {
          href: 
            '#/Pdf?pseudo=' +
            _ctx.pseudonyms +
            '&hor=' +
            _ctx.horizons +
            '&con=' +
            _ctx.connections +
            '&alt=' +
            _ctx.alteriNames +
            '&age=' +
            _ctx.showAge +
            '&role=' +
            _ctx.showRole +
            '&lang=' +
            _ctx.t('lang')
          ,
          target: "_blank",
          class: "button"
        }, [
          _createElementVNode("span", _hoisted_16, [
            _createVNode(_component_font_awesome_icon, { icon: "file-pdf" })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.t("createPDF")), 1)
        ], 8, _hoisted_15)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("a", _hoisted_18, _toDisplayString(_ctx.t("abouteasyNWK")), 1),
        _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.t("sourcecode")) + " (Version " + _toDisplayString(_ctx.appVersion) + ")", 1),
        _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.t("imprint")), 1),
        _hoisted_21
      ])
    ], 2)
  ]))
}